(function () {
  var wrappers = document.querySelectorAll('.collaboration-metaobject-detail__video');
  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    var video = wrapper.querySelector('.collaboration-metaobject-detail__video-element');
    if (!video) return;

    function applyLayout() {
      var w = video.videoWidth;
      var h = video.videoHeight;
      if (!w || !h) return;
      var portrait = h > w;
      wrapper.classList.toggle('collaboration-metaobject-detail__video--portrait', portrait);
      wrapper.classList.toggle('collaboration-metaobject-detail__video--landscape', !portrait);
    }

    if (video.readyState >= 1) applyLayout();
    else video.addEventListener('loadedmetadata', applyLayout, { once: true });
  });
})();
